import { Component, computed, OnInit, signal, ViewChild } from '@angular/core';
import { Utils } from './../../../common/utils';
import { GenericService } from 'src/app/services/generic/generic.service';
import { urlUpload, url_ws, valorAnd, valorOr } from 'src/app/config/config';
import { Table } from 'primeng/table';
import { environment } from 'src/environments/environment';
import { ImageBaseService } from '../../../services/imagenes/imagenes.service';
import * as html2canvas from 'html2canvas';
import * as jsPDF from 'jspdf-fix-png';
import { createPdfListOfertas } from './pdf/generatePdfOfertas';
import { SortEvent } from 'primeng/api';

import * as FileSaver from 'file-saver';
import * as Exceljs from 'exceljs';

const h2c: any = html2canvas;

@Component({
  selector: 'app-ofertas-list',
  templateUrl: './ofertas-list.component.html',
  styleUrls: ['./ofertas-list.component.css']
})
export class OfertasListComponent implements OnInit {

  @ViewChild('dt') dt!: Table;

  public cols = [
    { header: 'Foto', field: 'foto', width: '60px' },
    { header: 'Fecha creación', field: 'fecha_creacion', width: '100px', tipo: 'fecha' },
    { header: 'Proveedor', field: 'proveedor_abv', width: '90px' },
    { header: 'Nombre artículo', field: 'nombre' },
    { header: 'Descripción', field: 'descripcion' },
    { header: 'Maceta', field: 'maceta', width: '120px' },
    { header: 'Color', field: 'color', width: '190px' },
    { header: 'Tamaño', field: 'tamano', width: '140px' },
    { header: 'Unidades/piso', field: 'unidades_piso', width: '80px' },
    { header: 'Unidades/cc', field: 'unidades_cc', width: '80px' },
    { header: 'Precio neto vivero', field: 'precio_neto_vivero', width: '80px' },
    { header: 'Precio etiqueta artículo', field: 'precio_etiqueta_articulo', width: '80px' },
  ];

  public colsOffer = [
    {field: 'imagen' , header:'Foto'},
    {field: 'nombre' , header:'Artículo'},
    {field: 'proveedor' , header:'Descripcion'},
    {field: 'codcli' , header:'Cod.Cli'},
    {field: 'maceta' , header:'Maceta'},
    {field: 'tamanyo' , header:'Tamaño'},
    {field: 'unidades_piso' , header:'Ud/Piso'},
    {field: 'unidades_cc' , header:'Ud/cc'},
    { field: 'precio', header: 'Precio' },
    { field: 'precio_mix', header: 'Precio mixto' },
  ]

  public es = Utils.es;
  public urlUploadArticulo = urlUpload + "/articulos/";
  public expression = false;
  public display: boolean = true;
  public title = "Ofertas";
  public tituloEnAleman: boolean = false;
  public control: any = [];
  public mostrar = false;
  public showOferta: boolean = false;
  public hayOferta: boolean = false;
  public logoUrl = environment.logoUrl;

  public database = "warticulos";

  public first = 0;
  public selectedColumns: any[];
  public anchoTabla = "1500px";
  public showTables: boolean = true;
  public selectedProducts: any[] = [];
  public buscador: string = '';
  public auxitems: any[];
  public isGeneratingCanvas: boolean = false;
  public calculando: boolean = false;
  public fecha_actual: string = new Date().getDate() + '/' + (new Date().getMonth() + 1) + '/' + new Date().getFullYear();
  public clientes = {
    selected: null,
    values: [],
    filtered: [],
    label: 'Clientes...'
  };

  public logoBase64 = '';

  public oferta: Oferta = {};

  isActive = false;

  constructor(
    private genericService: GenericService,
    private imageBaseService: ImageBaseService
  ) {
    this.showCols();
  }

  ngOnInit(): void {

    this.iniciar();

    let interval = setInterval(async (params) => {

      if (localStorage.getItem("CLIENT_SELECTED")) {
        this.clientes.selected = localStorage.getItem("CLIENT_SELECTED");
      }
      clearInterval(interval)
    });

  }

  iniciar() {
    this.mostrar = false;
    this.cargaClientes();

    this.imageBaseService.image64(url_ws + "upload/resources/logo.jpg").subscribe((data: any) => {
      this.logoBase64  = data;
    })

    this.genericService.getListSimple(this.database, 'fecha_creacion_for_list').toPromise().then((data: any) => {

      this.control = data.productos;

      this.control.forEach(c => {
        c.fecha_creacion = c.fecha_creacion_for_list;
      });

      this.auxitems = [...this.control];

      this.mostrarTabla();

    }).catch(error => {
      console.log("Error", error);
    });
  }

  cargaClientes() {

    this.genericService.getListSimple('clientes', 'nombre').toPromise().then((data: any) => {
      const relClientes = data.productos;
      relClientes.forEach(element => {


        this.clientes.filtered.push(
          {
            label: element.nombre + ' ' + element.departamento,
            value: element.id,
            domicilio: element.direccion,
            pais: element.pais,
            cp: element.cp,
            poblacion: element.localidad,
            provincia: element.provincia,
            telefono: element.telefono,
            condicion: element.condicion == null ? 0 : element.condicion,
            tipo_precio: element.tipo_precio_facturacion,
            precio_cc_transporte: element.precio_cc_transporte == null ? 0 : element.precio_cc_transporte,
            precio_camion_completo: element.precio_camion_completo == null ? 0 : element.precio_camion_completo,
            precio_comision_carro: element.precio_comision_carro == null ? 0 : element.precio_comision_carro
          });
      });


    }).catch(error => {
      console.log("Error", error);
    });

  }

  async creaOferta() {
    this.calculando = true;

    if (this.clientes.selected == null || this.clientes.selected.length == 0) {
      this.showOferta = false;
      alert('Debe selecionar un cliente');
      return;
    } else if (this.clientes.selected != localStorage.getItem("CLIENT_SELECTED")) {
      localStorage.setItem("CLIENT_SELECTED", this.clientes.selected);
    }

    const idCliente = this.clientes.selected;

    this.clientes.filtered.forEach(element => {

      if (element.value == idCliente) {
        this.oferta.nombre = element.label;
        this.oferta.direccion = element.domicilio;
        this.oferta.cp = element.cp;
        this.oferta.poblacion = element.poblacion;
        this.oferta.provincia = element.provincia;
        this.oferta.pais = element.pais;
        this.oferta.telefono = element.telefono;
        this.oferta.condicion = element.condicion;
        this.oferta.precio_camion_competo = element.precio_camion_completo;
        this.oferta.tipo_precio = element.tipo_precio.substr(0, 3);
        this.oferta.precio_cc_transporte = element.precio_cc_transporte;
        this.oferta.precio_comision_carro_cliente = element.precio_comision_carro;
      }
    });

    this.colsOffer.forEach(element => {
      if (element.field == 'precio') {
        element.header =  'Precio (' + this.oferta.tipo_precio + ')';
      }

      if (element.field == 'precio_mix') {
        element.header = 'Precio mixto (' + this.oferta.tipo_precio + ')';
      }
    });

    this.oferta.articulos = [];
    for (let index = 0; index < this.selectedProducts.length; index++) {
      const element = this.selectedProducts[index];

      let image64 = '';
      let ancho: number = 150;
      let alto: number = 80;

      if (element.archivo1 != null) {
        if (element.archivo1.trim().length > 0) {
          //Si el nombre de la imagen contiene espacios, arreglo la url para que los espacios no afecte a la peticion
          element.archivo1 = element.archivo1.replace(/ /g, '%20');
          image64 = await this.imageBaseService.image64(urlUpload + 'articulos/' + element.archivo1).toPromise();
          let resp = await this.imageBaseService.getDimensionImage(urlUpload + 'articulos/' + element.archivo1);
          if (resp.height > resp.width) {
            ancho = 80;
            alto = 150;
          }
        }
      };

      let articulo: OfertaArticulo = {
        proveedor: element.proveedor_abv,
        nombre: element.nombre,
        color: element.color,
        tamanyo: element.tamano,
        precio_neto_vivero: element.precio_neto_vivero,
        precio_etiqueta_articulo: element.precio_etiqueta_articulo,
        precio_comision_articulo: element.precio_comision_articulo,
        precio_comision_carro: this.oferta.precio_comision_carro_cliente == '0' ? element.precio_comision_carro : this.oferta.precio_comision_carro_cliente,
        unidades_cc: element.unidades_cc,
        unidades_piso: element.unidades_piso,
        precio_transporte: element.precio_transporte,
        imagen: image64,
        ancho: ancho,
        alto: alto,
        descripcion: element.descripcion,
        maceta: element.maceta,
        codcli: ''

      };

      const nomcli = this.oferta.nombre;

      if (nomcli.includes('Blume')) {
        articulo.codcli = element.codigo_blume2000;
      } else if (nomcli.includes('Dehner')) {
        articulo.codcli = element.codigo_dehner;
      } else if (nomcli.includes('Schmid')) {
        articulo.codcli = element.codigo_schmid;
      } else if (nomcli.includes('Transportgemeinschaft')) {
        articulo.codcli = element.codigo_migros;
      } else if (nomcli.includes('Irsslinger')) {
        articulo.codcli = element.codigo_irsslinger;
      } else if (nomcli.includes('Landgard')) {
        articulo.codcli = element.codigo_landgard;
      } else {
        articulo.codcli = element.codigo_generico;
      }

      articulo.precio = this.oferta.tipo_precio === 'EXW' ? this.getPrecioEXV(articulo) : this.oferta.tipo_precio === 'FCA' ? this.getPrecioFCA(articulo, this.oferta) : this.getPrecioDDP(articulo, this.oferta);
      articulo.precio = articulo.precio.toString().replace('.', ',');

      articulo.precio_mix = this.oferta.tipo_precio === 'EXW' ? this.getPrecioEXVMixto(articulo) : this.oferta.tipo_precio === 'FCA' ? this.getPrecioFCAMixto(articulo, this.oferta) : this.getPrecioDDP(articulo, this.oferta);
      articulo.precio_mix = articulo.precio_mix.toString().replace('.', ',');

      console.log(articulo);

      this.oferta.articulos.push(articulo);
      if ((index + 1) >= this.selectedProducts.length) {
        this.showOferta = true;
      }
    }

    this.calculando = false;

  }


  async imprimePdf() {
    this.calculando = true;
    let logo = await this.imageBaseService.image64(environment.serverUrl + this.logoUrl).toPromise();
    this.tituloEnAleman = true;
    createPdfListOfertas(logo, this.oferta, this.fecha_actual);
    this.tituloEnAleman = false;
    this.calculando = false;
  }

  showCols() {
    this.showTables = true;

    this.anchoTabla = "1500px";
    this.selectedColumns = this.cols;
  }


  mostrarTabla() {
    this.mostrar = true;
  }

  cerrar() {
    this.display = false;
    this.expression = false;
  }

  closeWindow(event) {
    this.cerrar();
  }

  mydt: any;

  cambios(dt) {

    this.mydt = dt;

  }

  customSort(event: SortEvent) {
    event.data.sort((data1, data2) => {
      //console.log('field',event.field);

      let value1 = data1[event.field];
      let value2 = data2[event.field];
      let result = null;

      if (value1 == null && value2 != null)
        result = -1;
      else if (value1 != null && value2 == null)
        result = 1;
      else if (value1 == null && value2 == null)
        result = 0;

      else if (typeof value1 === 'string' && typeof value2 === 'string')
        result = value1.localeCompare(value2);
      else
        result = (value1 < value2) ? -1 : (value1 > value2) ? 1 : 0;

      return (event.order * result);
    });
  }

  buscadorEspecial(value: string) {

    this.control = [...this.auxitems];

    if (value == null || value == undefined || value.length <= 0) {
      this.control = [...this.auxitems];
    } else {
      if (value.includes(valorAnd)) {
        let valores = value.split(valorAnd);
        let control = [];
        for (let index = 0; index < valores.length; index++) {
          if (this.comprobarSiHayValorDefinido(valores[index])) {
            const element = valores[index];
            control = this.buscadorSimple(element);
            this.control = this.quitarDuplicados(control);
          }
        }
      } else if (value.includes(valorOr)) {
        let valores = value.split(valorOr);
        this.control = this.quitarDuplicados(this.buscadorCompuesto(valores));
      } else {
        let control = this.quitarDuplicados(this.buscadorSimple(value))
        this.control = control;
      }
    }
    this.mydt = this.dt;
  }

  buscadorSimple(value: string) {
    let control = [];
    for (let index = 0; index < this.control.length; index++) {
      const element = this.control[index];
      for (const iterator in element) {
        //console.log('iterator', this.control[index][iterator]);
        if (this.comprobarSiHayValorDefinido(this.control[index][iterator])) {
          //console.log('value si hay valor', this.control[index][iterator].toString().toLowerCase(), value.toLowerCase());
          if ((this.control[index][iterator].toString()).toLowerCase().normalize("NFD").replace(new RegExp(/[\u0300-\u036f]/g), "").includes(value.toLocaleLowerCase().normalize("NFD").replace(new RegExp(/[\u0300-\u036f]/g), ""))) {
            /*  console.log(this.control[index][iterator],value); */

            control.push(this.control[index]);
          }
        }

      }
    }

    return control;
  }

  comprobarSiHayValorDefinido(value): boolean {
    if (value == null || value == undefined || value.length <= 0) {
      return false;
    } else {
      return true;
    }
  }

  quitarDuplicados(etiquetas: any[]) {
    let item = [];
    let discriminador = true;
    for (let index = 0; index < etiquetas.length; index++) {
      etiquetas[index].id;
      for (let index2 = 0; index2 < item.length; index2++) {
        if (item[index2].id == etiquetas[index].id) {
          discriminador = false;
        } else {
          discriminador = true;
        }

      }
      if (discriminador) {
        item.push(etiquetas[index]);
      } else {
        discriminador = true;
      }
    }
    return item;
  }

  buscadorCompuesto(value: string[]) {
    let control = [];
    for (let index = 0; index < this.control.length; index++) {
      const element = this.control[index];
      for (const iterator in element) {
        //console.log('iterator', this.control[index][iterator]);
        if (this.comprobarSiHayValorDefinido(this.control[index][iterator])) {
          //console.log('value si hay valor', this.control[index][iterator], value);
          for (let index2 = 0; index2 < value.length; index2++) {
            const element2 = value[index2];
            if (this.comprobarSiHayValorDefinido(element2)) {
              if ((this.control[index][iterator] as string).toLowerCase().normalize("NFD").replace(new RegExp(/[\u0300-\u036f]/g), "").includes(element2.toLocaleLowerCase().normalize("NFD").replace(new RegExp(/[\u0300-\u036f]/g), ""))) {
                /*  console.log(this.control[index][iterator],value); */
                control.push(this.control[index]);
              }
            }

          }

        }

      }
    }

    return control;
  }

  public scrollToTop(event: any) {
    const elements = document.getElementsByClassName('ui-dialog-content ui-widget-content');
    if (elements && elements[0]) {
      setTimeout(() => {
        elements[0].scrollTop = 0;
      }, 100);
    }
  }

  public decimalFormat(input: any, nDecimals?: number, millar?: string, comma?: string, progressiveTo?: number) {
    if (!input) {
      return '';
    }
    return Utils.decimalFormat(input, nDecimals, millar, comma, progressiveTo);
  }

  public getPrintConfig() {
    const config = {
      canvasScale: 2,
      orientation: 'l',
      width: 290,
      height: 210
    };
    return config;
  }

  public async imprimirReceta() {

    this.isGeneratingCanvas = true;
    const config = this.getPrintConfig();

    h2c(document.getElementById('html2canvasDivOferta'), { scale: config.canvasScale, logging: false }).then(canvas => {
      this.isGeneratingCanvas = false;
      const pdf = new jsPDF(config.orientation, 'mm', 'a4');
      const data = canvas.toDataURL('image/png');
      if (canvas.width > canvas.height) {
        pdf.addImage(data, 'png', 0, 0, config.width, (canvas.height / (canvas.width / config.width)), 'alias', 'FAST');
      } else {
        pdf.addImage(data, 'png', 0, 0, (canvas.width / (canvas.height / config.height)), config.height, 'alias', 'FAST');
      }
      pdf.save(
        'Oferta'
      );

    });
  }


  public async generateExcel() {

    // Creo el libro excel
    const wb = new Exceljs.Workbook();
    wb.created = new Date();
    wb.creator = "VPE";

    // Creo una hoja en blanco
    const ws = wb.addWorksheet('Sheet1', {
      pageSetup:{paperSize: 9, orientation:'landscape'}
    });


    //Añado el logo
    const logo = wb.addImage({base64: this.logoBase64, extension: 'png'});
    ws.addImage(logo,{tl:{col: 0.1125, row: 0.4},ext:{width: 400, height: 120},editAs:'oneCell'});

    //Recogo la posicion donde van a ir la informacion de cabecera
    const rowInfoName = ws.getRow(8);
    const rowInfoDirection = ws.getRow(9);
    const rowInfoCP = ws.getRow(10);
    const rowInfoProvince = ws.getRow(11);
    const rowInfoCountry = ws.getRow(12);
    const rowInfoTel = ws.getRow(13);

    const headerCellNumber = 10;

    //Añado la informacion del cliente
    this.oferta.nombre.length > 0 ? rowInfoName.getCell(headerCellNumber).value = this.oferta.nombre : '';
    this.oferta.direccion.length > 0 ? rowInfoDirection.getCell(headerCellNumber).value = this.oferta.direccion : '';
    this.oferta.cp.length > 0 ? rowInfoCP.getCell(headerCellNumber).value = this.oferta.cp : '';
    this.oferta.provincia.length > 0 ? rowInfoProvince.getCell(headerCellNumber).value = this.oferta.provincia : '';
    this.oferta.pais.length > 0 ? rowInfoCountry.getCell(headerCellNumber).value = this.oferta.pais: '';
    this.oferta.telefono.length > 0 ? rowInfoTel.getCell(headerCellNumber).value = this.oferta.telefono : '';

    ws.addRow([this.fecha_actual])
    ws.addRow(['DETALLE ARTÍCULOS']);

    // const headersTable:any = ['Foto','Proveedor','Artículo','Descripción','Cod.Cli','Maceta','Tamaño','Ud/Piso','Ud/cc','Precio EXW','Precio Mixto'];
    // ws.insertRow(15, headersTable);

    let rowsTable = [];

    for (let i = 0; i < this.oferta.articulos.length; i++) {
      const articulo = this.oferta.articulos[i];
      const elementsRow = [];

      const keys = ['imagen','proveedor','nombre','descripcion','codcli','maceta','tamanyo','unidades_piso','unidades_cc','precio','precio_mix'];

      keys.forEach(element => {
        if(element == 'imagen') {
          elementsRow.push('.');
        }else if(element == 'precio' || element == 'precio_mix') {
          const rawValue = articulo[element];
          if (rawValue !== undefined && rawValue !== null && rawValue !== '') {
            const cleanValue = rawValue.toString().replace(',', '.');
            const numValue = parseFloat(cleanValue);
            elementsRow.push(isNaN(numValue) ? null : numValue);
          } else {
            elementsRow.push(null);
          }
        }else {
          elementsRow.push(articulo[element]);
        }
      });
      rowsTable.push(elementsRow);
    }

    let labelColumnPrice = "Precio " + this.oferta.tipo_precio  ;
    let labelColumnPriceMixto = "Precio Mixto" + (this.oferta.tipo_precio == 'EXV' ? ' (EXV)' : '');

    ws.addTable({
      name: 'MyTable',
      ref: 'A17',
      headerRow: true,
      totalsRow: true,
      style: {
        theme: 'TableStyleLight1',
      },
      columns: [
        {name: 'Foto'},
        {name: 'Proveedor'},
        {name: 'Artículo'},
        {name: 'Descripción'},
        {name: 'Cod.Cli'},
        {name: 'Maceta'},
        {name: 'Tamaño'},
        {name: 'Ud/Piso'},
        { name: 'Ud/cc', totalsRowLabel: 'Total:' },
        { name: labelColumnPrice, totalsRowFunction: 'sum' },
        { name: labelColumnPriceMixto, totalsRowFunction: 'sum' }
      ],
      rows: rowsTable,
    });

    ws.getColumn('A').width = 30

    // Formato numérico de dos decimales para las columnas J (Precio) y K (Precio Mixto)
    ws.getColumn('J').numFmt = '#,##0.00';
    ws.getColumn('K').numFmt = '#,##0.00';

    for (let i = 0; i < this.oferta.articulos.length; i++) {
      let row = 18 + i;
      ws.getRow(row).height = 90;
      const element = this.oferta.articulos[i];
      if(element.imagen) {
        var imgId = wb.addImage({base64: element.imagen, extension: 'png'});
        ws.addImage(imgId,{tl:{col: 0.5, row: (17+i)},ext: {width: 100,height:100}});
      }
    }

    //  Funcion que hace que las tengan el tamaño del contenido
    ws.columns.forEach(function (column, i) {
      let maxLength = 0;
      column["eachCell"]({ includeEmpty: true }, function (cell) {
        var columnLength = cell.value ? cell.value.toString().length : 10;
        if (columnLength > maxLength) {
          maxLength = columnLength;
        }
      });
      column.width = maxLength < 10 ? 10 : maxLength;
    });

    ws.getRow(18).height = 80;

    // Genero el archivo XLSX
    wb.xlsx.writeBuffer().then((buffer) => {
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      FileSaver.saveAs(blob, `oferta.xlsx`);
    });
  }

  getPrecioEXV(articulo: OfertaArticulo): string {
    const comision = Number(articulo.precio_comision_articulo) != 0 ? (Number(articulo.precio_comision_articulo) / 100) * Number(articulo.precio_neto_vivero) : 0;
    let precio = Number(articulo.precio_neto_vivero) + comision;

    let comisionProveedor = 0;

    if (Number(articulo.precio_transporte) != 0 && Number(articulo.unidades_cc) != 0) {
      comisionProveedor = Number(articulo.precio_transporte) / Number(articulo.unidades_cc);
    }
    precio = precio + comisionProveedor + Number(articulo.precio_etiqueta_articulo);
    return precio.toFixed(2);
  }

  getPrecioEXVMixto(articulo: OfertaArticulo): string {
    const comision_cc = Number(articulo.precio_comision_carro) / Number(articulo.unidades_cc);
    const precioEXV = Number(this.getPrecioEXV(articulo));
    return (precioEXV + comision_cc).toFixed(2);
  }

  getPrecioFCA(articulo: OfertaArticulo, oferta: Oferta): string {
    const precioEXV = Number(this.getPrecioEXV(articulo));
    let precio = precioEXV + (precioEXV * Number(oferta.condicion) / 100); // Number(this.getPrecioEXV(articulo)) * Number(oferta.condicion) / 100;

    return precio.toFixed(2);
  }

  getPrecioFCAMixto(articulo: OfertaArticulo, oferta: Oferta): string {
    const precioEXVMixto = Number(this.getPrecioEXVMixto(articulo));
    let precio = precioEXVMixto + (precioEXVMixto * Number(oferta.condicion) / 100);

    return precio.toFixed(2);
  }

  getPrecioDDP(articulo: OfertaArticulo, oferta: Oferta): string {

    const pcc = Number(oferta.precio_camion_competo);
    const ucc = Number(articulo.unidades_cc);
    const pcct = Number(oferta.precio_cc_transporte);

    let precio: number = pcc != 0 ? pcc : ucc != 0 ? pcct / ucc : 0
    precio = precio + Number(this.getPrecioFCA(articulo, oferta));
    return precio.toFixed(2);
  }

  onFilter(event: any) {
    if (event.checked) {
      this.control = this.control.filter((item: any) => item.activo);
    } else {
      this.control = [...this.auxitems];
    }
  }
}

export interface OfertaArticulo {
  proveedor?: string;
  nombre?: string;
  color?: string;
  tamanyo?: string;
  precio_neto_vivero?: string;
  precio_etiqueta_articulo?: string;
  precio_comision_articulo?: string;
  precio_comision_carro?: string;
  unidades_cc?: string;
  unidades_piso?: string;
  precio_transporte?: string;
  precio?: string;
  imagen?: string;
  ancho?: number;
  alto?: number;
  descripcion?: string;
  maceta?: string;
  codcli?: string;
  precio_mix?: string;

}

export interface OfertaPack {
  imagen?: string;
  nombre?: string;
  ancho?: number;
  alto?: number;
  observaciones?: string;
  articulos?: OfertaArticulo[];
}

export interface Oferta {
  nombre?: string;
  direccion?: string;
  cp?: string;
  poblacion?: string;
  provincia?: string;
  pais?: string;
  telefono?: string;
  condicion?: string;
  tipo_precio?: string;
  precio_cc_transporte?: string;
  precio_camion_competo?: string;
  articulos?: OfertaArticulo[];
  packs?: OfertaPack[];
  precio_comision_carro_cliente?: string;
}
